import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=3056db6c&scoped=true&"
import script from "./FloatingChat.vue?vue&type=script&lang=js&"
export * from "./FloatingChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=3056db6c&prod&scoped=true&lang=css&"
import style1 from "./FloatingChat.vue?vue&type=style&index=1&id=3056db6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056db6c",
  null
  
)

export default component.exports